import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

/**
 * Service de documentation
 */
@Injectable({
  providedIn: 'root'
})
export class FacturationService {

    /**
     * Constructeur
     * @param http
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Paginer les factures
     * @param indexPage
     * @param nombreElements
     * @param codesFournisseur
     * @param dateDebut
     * @param dateFin
     */
    paginerFactures(indexPage: number, nombreElements: number, codesFournisseur: string[], dateDebut: Date, dateFin: Date, tris: any[]): any {
        let body = {
            Indice: indexPage,
            NombreElements: nombreElements,
            DateDebut: dateDebut ? dateDebut.toJSON() : '',
            DateFin: dateFin ? dateFin.toJSON() : '',
            CodesFournisseur: codesFournisseur,
            Tris: tris
        }

        return this.http.post(`api/facturation/paginerfacturesfast`, body).pipe(map((retour: any[]): any[] => { return retour }));
    }

    /**
     * T�l�charger une facture
     * @param numeroFacture
     * @param codeFournisseur
     * @param typeSortieFacture
     */
    telechargerFacture(numeroFacture: string, codeFournisseur: string, typeSortieFacture: string) {
        window.open(`api/facturation/telechargerfacturefast?NumeroFacture=` + numeroFacture + `&CodeFournisseur=` + codeFournisseur + `&TypeSortieFacture=` + typeSortieFacture + `&Inline=false`, '_blank');
    }

    /**
     * Afficher une facture
     * @param numeroFacture
     * @param codeFournisseur
     * @param typeSortieFacture
     */
    afficherFacture(numeroFacture: string, codeFournisseur: string, typeSortieFacture: string) {
        window.open(`api/facturation/telechargerfacturefast?NumeroFacture=` + numeroFacture + `&CodeFournisseur=` + codeFournisseur + `&TypeSortieFacture=` + typeSortieFacture + `&Inline=true`, '_blank');
    }
}
